<template>
    <div>
        <el-form :inline="true" :model="param" class="demo-form-inline">
            <el-form-item label="问题分类">
                <el-select v-model="param.problem" placeholder="请选择问题分类">
                    <el-option
                            v-for="item in problemOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
                <!--   <el-input v-model="param.problem" placeholder="请输入问题分类"></el-input>
               --></el-form-item>
            <el-form-item label="关键字">
                <el-input v-model="param.keyword" placeholder="请输入关键字"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="loaddata">查询</el-button>
            </el-form-item>
        </el-form>
        <el-row>
            <!--<el-col :span='10'>员工状态 {{state}} | 打卡次数: {{daka}}</el-col>-->
            <!--<el-col :span='10' >打卡次数: {{daka}} </el-col>
            <el-col :span='10' >缺卡次数: {{queka}} </el-col>-->
            <el-col :span="12" style="margin-bottom: 10px">
                <!--<el-button type="primary" @click="showAdd">录入</el-button>-->
                <el-button type="primary" @click="toLogin">后台</el-button>
                <!--<el-button type="success" @click="changeState(1)" :disabled='downData'>下班打卡</el-button>
                <el-button type="danger" @click="changeState(2)" :disabled='outData'>外出打卡</el-button>
                <el-button type="warning" @click="changeState(3)" :disabled='returnData'>返回打卡</el-button>-->
            </el-col>
        </el-row>

        <el-table
                :data="page"
                border
                style="width: 100%"
                :default-sort="{prop: 'time', order: 'descending'}"
        >
            <el-table-column
                    prop="TITLE"
                    label="知识标题"
            >
            </el-table-column>
            <el-table-column
                    prop="relations"
                    label="知识关联系统"
                    :formatter="checkRel"
            >
            </el-table-column>
            <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                    <button
                            size="mini"
                            class="button2"
                            @click="look(scope.row)"
                    >打开
                    </button>
                    <button
                            v-if="scope.row.STATUS==='3'"
                            size="mini"
                            class="button2"
                            @click="edit(scope.row)"
                    >编辑
                    </button>
                    <button
                            v-if="scope.row.STATUS==='1'"
                            size="mini"
                            class="button2"
                            @click="approve(scope.row,'2')"
                    >审核通过
                    </button>
                    <button
                            v-if="scope.row.STATUS==='1'"
                            size="mini"
                            class="button2"
                            @click="approve(scope.row,'3')"
                    >审核拒绝
                    </button>
                </template>
            </el-table-column>

        </el-table>
        <!--<el-pagination
                small
                layout="prev, pager, next"
                :page-size="param.pageSize"
                :current-page="param.pageIndex"
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
                :total="total">
        </el-pagination>-->

        <!-- 添加或修改商品详情对话框 -->
        <el-dialog title="知识信息" :visible.sync="open" width="700px" hieght="900px" append-to-body>

            <el-form ref="form" :model="employer" label-width="80px">
                <el-input v-model="employer.id" v-show="false"></el-input>
                <el-form-item label="标题">
                    <el-input v-model="employer.title"></el-input>
                </el-form-item>
                <el-form-item label="关联系统">
                    <el-select v-model="employer.relation" multiple placeholder="请选择关联系统">
                        <el-option
                                v-for="item in relationOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>


                <el-form-item label="关键字" >
                    <el-input v-model="employer.keyword"></el-input>
                </el-form-item>
                <el-form-item label="问题描述" >
                    <!--<el-input v-model="employer.describe"></el-input>-->
                    <quill-editor
                            :content="employer.describe"
                            :options="editorOption"
                            @change="onEditorChange($event)"
                    />
                </el-form-item>
                <el-form-item label="解决方式">
                    <quill-editor
                            :content="employer.solution"
                            :options="editorOption"
                            @change="onEditorChange1($event)"/>
                </el-form-item>
             

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm" v-show="!showLook">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>


</template>

<style>
</style>

<script>
    export default {
        data() {
            return {
                open: false,
                page: [],
                employer: {
                    id: '',
                    title: '',
                    problem: '',
                    keyword: '',
                    describe: '',
                    solution: '',
                    relation: ''
                },
                param: {
                    pageIndex: 1,
                    pageSize: 2,
                    problem: '',
                    keyword: '',
                    status:'2'
                },
                state: '',
                problemOptions: [],
                relationOptions: [],
                total: 0,
                content: '<h2>I am Example</h2>',
                editorOption: {
                    // Some Quill options...
                },
                showLook:false
            }
        },
        computed: {
            editor() {
                return this.$refs.myQuillEditor.quill
            }
        },
        created() {
            this.loaddata();
            this.loadproblemOptions()
            this.loadrelationOptions()

            //this.loadstate()
        },
        methods: {
            look(row) {
                this.setData(row);
                this.showInfo(row);
                this.open = true
                this.showLook = true
            },
            edit(row) {
                this.setData(row);
                this.open = true
            },
            approve(row, status) {
                this.$http.post('/info/updateStatus', {id: row.ID, status: status}).then(res => {
                    if (res.data.code === '1') {
                        //去登陆
                        window.sessionStorage.removeItem('token');
                        this.$router.replace({path: '/login'});
                    }
                    this.$message({
                        message: '审核成功',
                        type: 'success'
                    });
                    this.loaddata();
                    //this.open = false
                    //this.$router.push('/employer/AllEmployer');
                })
            },
            toLogin() {
                //this.reset()
                this.$router.replace({path: '/login'});
                //this.open = true
            },
            submitForm() {
                console.log(this.employer)
                let rela = this.employer.relation
                if(rela.length!==0){
                    let real = '';
                    for (let i = 0; i <rela.length ; i++) {
                        real+= rela[i]+','
                    }
                    this.employer.relation = real
                }

                this.$http.post('/info/add',this.employer).then(res => {
                    if (res.data.code === '1') {
                        //去登陆
                        window.sessionStorage.removeItem('token');
                        this.$router.replace({path: '/login'});
                    }
                    this.$message({
                        message: '添加成功',
                        type: 'success'
                    });
                    this.open = false
                    this.loaddata();
                    //this.$router.push('/employer/AllEmployer');
                })
            },
            handlePageChange(currentPage) {
                this.param.pageIndex = currentPage
                // 在此刷新数据
                this.loaddata()
            },
            handleSizeChange(pageSize) {
                this.param.pageSize = pageSize
                // 在此刷新数据
                this.loaddata()
            },
            loaddata() {
                this.$http.post('/info/list', this.param).then(res => {
                  console.log('游客登陆加载数据',res)
                    if (res.data.code === '1') {
                        //去登陆
                        window.sessionStorage.removeItem('token');
                        this.$router.replace({path: '/login'});
                    }
                    this.page = res.data.data.list;
                    this.total = res.data.data.total;
                });
            },
            checkRel(row) {
                let relations = row.relations
                if (relations.length !== 0) {
                    let res = '';
                    for (let i = 0; i < relations.length; i++) {
                        console.log(relations[i])
                        res += relations[i]['RELATIONMNAME'] + ','
                    }
                    return res
                }
                //return ''
            }
            ,
            loadproblemOptions() {
                this.$http.post('info/getKeyByDname', {dname: 'PROBLEM'}).then(res => {
                    if (res.data.code === '1') {
                        //去登陆
                        window.sessionStorage.removeItem('token');
                        this.$router.replace({path: '/login'});
                    }
                    console.log(res)
                    let r = res.data.data;
                    if (r.length != 0) {
                        this.problemOptions = []
                        for (let i = 0; i < r.length; i++) {
                            let m = {}
                            m['label'] = r[i].DVAL
                            m['value'] = r[i].DKEY
                            this.problemOptions.push(m)
                        }
                        console.log('jihe', this.problemOptions)
                    }
                });
            }
            ,
            loadrelationOptions() {
                this.$http.post('info/getKeyByDname', {dname: 'RELATION'}).then(res => {
                    if (res.data.code === '1') {
                        //去登陆
                        window.sessionStorage.removeItem('token');
                        this.$router.replace({path: '/login'});
                    }
                    console.log(res)
                    let r = res.data.data;
                    if (r.length != 0) {
                        this.relationOptions = []
                        for (let i = 0; i < r.length; i++) {
                            let m = {}
                            m['label'] = r[i].DVAL
                            m['value'] = r[i].DKEY
                            this.relationOptions.push(m)
                        }
                        console.log('jihe', this.relationOptions)
                    }
                });
            }
            ,
            onEditorChange({quill, html, text}) {
                console.log('editor change!', quill, html, text)
                this.employer.describe = html
            }
            ,
            onEditorChange1({quill, html, text}) {
                console.log('editor change!', quill, html, text)
                this.employer.solution = html
            },

            cancel() {
                this.open = false
                this.showLook = false
                this.reset()
            },
            reset() {
                this.employer.id = ''
                this.employer.title = ''
                this.employer.problem = ''
                this.employer.keyword = ''
                this.employer.describe = ''
                this.employer.solution = ''
                this.employer.relation = ''
                this.employer.num = ''
                this.employer.createTime = ''
                this.employer.userName = ''
                this.employer.examineName =''
                this.employer.examineTime = ''
                this.employer.statusName = ''
                this.showLook = false
            },
            setData(row) {
                this.reset()
                console.log(row)
                this.employer.id = row.ID
                this.employer.title = row.TITLE
                this.employer.problem = row.PROBLEM
                this.employer.keyword = row.KEYWORD
                this.employer.describe = row.DESCRIBE
                this.employer.solution = row.SOLUTION

                let data = []
                for (let i = 0; i < row.relations.length; i++) {
                    data.push(row.relations[i].NAME)
                }
                console.log(data)
                this.employer.relation = data
                /*this.employer.title =  row.TITLE
                this.employer.title =  row.TITLE*/
            },
            showInfo(row){
                this.employer.num = row.NUM
                this.employer.createTime = row.CREATETIME
                this.employer.userName = row.USERNAME
                this.employer.examineName = row.EXAMINENAME
                this.employer.examine = row.EXAMINE
                this.employer.examineTime = row.EXAMINETIME
                this.employer.statusName = row.STATUSNAME
            }


        }
    }
</script>
